module.exports = "data:application/font-woff;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICIzYTc1Zjk0NDE3MDdmZTNkMmQ5M2ZiYmY2M2QzNWM1Ni5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 1187
// module chunks = 1